import { Inject, Injectable, Optional } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { NGX_SHARED_CONFIG } from './config.token';
import * as i0 from "@angular/core";
const defaultConfig = {
    bootstrapVersion: 'v5',
};
export class ConfigService {
    constructor(config) {
        this.config = config;
        this.config$ = new BehaviorSubject(defaultConfig);
        if (config) {
            this.config$.next(this.config);
        }
    }
    overrideConfig(c) {
        this.config = Object.assign(Object.assign({}, this.config), c);
        this.config$.next(this.config);
    }
    get bootstrapVersion$() {
        return this.config$.asObservable().pipe(map((c) => c.bootstrapVersion));
    }
}
ConfigService.ɵfac = function ConfigService_Factory(t) { return new (t || ConfigService)(i0.ɵɵinject(NGX_SHARED_CONFIG, 8)); };
ConfigService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigService, factory: ConfigService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NGX_SHARED_CONFIG]
            }] }]; }, null); })();
